import { useState } from "react";
import {
  disabledCommittee,
  getAllCommittees,
  getAllCommitteesByLanguageId,
  getAllCommitteesMettings,
  getAllSlotCommittees,
  getCommitteeById,
  getCommitteeSummaryById,
  newCommittee,
  updateCommittee
} from "../services/committees.service";

const INITIAL_SUCCESS_ERROR = {
  getAllCommittees: "",
  getCommitteeById: "",
  getAllSlotCommittees: "",
  getAllCommitteesByLanguageId: "",
  getAllCommitteesMettings: "",
  disabledCommittee: "",
  create: "",
  update: "",
};

export const useCommittees = ({ spinner }) => {
  const [committeesList, setCommitteesList] = useState([]);
  const [committeesListSelect, setCommitteesListSelect] = useState([]);
  const [finalElevationList, setFinalElevationList] = useState([]);
  const [committee, setCommittee] = useState({});
  const [committeeSummary, setCommitteeSummary] = useState({});
  const [success, setSuccess] = useState(INITIAL_SUCCESS_ERROR);
  const [error, setError] = useState(INITIAL_SUCCESS_ERROR);

  const getCommittees = async (params, listSelect = false) => {
    clearAlerts();
    spinner(true);
    const response = await getAllCommittees(params);
    spinner(false);
    if (response.error) {
      setCommitteesList([]);
      if (listSelect) setCommitteesListSelect([]);
      setError({ getAllChairPerson: response.error });
    } else {
      setCommitteesList(response.data);
      if (listSelect) setCommitteesListSelect(response.data);
    }

    return response;
  };

  const getCommitteesSlot = async (params, listSelect = false) => {
    clearAlerts();
    spinner(true);
    const response = await getAllSlotCommittees(params);
    spinner(false);
    if (response.error) {
      setCommitteesList([]);
      if (listSelect) setCommitteesListSelect([]);
      setError({ getAllChairPerson: response.error });
    } else {
      setCommitteesList(response.data);
      if (listSelect) setCommitteesListSelect(response.data);
    }
  };

  const getCommitteesMettings = async (listSelect = false) => {
    clearAlerts();
    spinner(true);
    const response = await getAllCommitteesMettings();
    spinner(false);
    if (response.error) {
      setCommitteesList([]);
      if (listSelect) setCommitteesListSelect([]);
      setError({ getAllChairPerson: response.error });
    } else {
      setCommitteesList(response.data);

      if (listSelect) setCommitteesListSelect(response.data);
    }
  };

  const getCommitteesByLanguageId = async (languageId) => {
    clearAlerts();
    spinner(true);
    const response = await getAllCommitteesByLanguageId(languageId);
    spinner(false);
    if (response.error) {
      setCommitteesListSelect([]);
      setError({ getAllCommitteesByLanguageId: response.error });
    } else {
      setCommitteesListSelect(response.data);
    }
  };

  const getActiveCommitteesByLanguageId = async (languageId) => {
    clearAlerts();
    spinner(true);
    const response = await getAllCommitteesByLanguageId(languageId);
    spinner(false);
    if (response.error) {
      setCommitteesListSelect([]);
      setError({ getAllCommitteesByLanguageId: response.error });
    } else {
      setCommitteesListSelect(response.data.filter(committee => committee.status !== "Inativo"));
    }
  };

  const getFinalElevationByLanguageId = async (languageId) => {
    clearAlerts();
    spinner(true);
    const response = await getAllCommitteesByLanguageId(languageId);
    spinner(false);
    if (response.error) {
      setFinalElevationList([]);
      setError({ getAllCommitteesByLanguageId: response.error });
    } else {
      setFinalElevationList(response.data.filter(committee => committee.status !== "Inativo"));
    }
  };

  const getCommittee = async (id) => {
    clearAlerts();
    const response = await getCommitteeById(id);
    if (response.error) {
      setCommittee({});
      setError({ getCommitteeById: response.error });
    } else {
      setCommittee(response.data);
    }
  };

  const getCommitteeSummary = async (id) => {
    clearAlerts();
    const response = await getCommitteeSummaryById(id);
    if (response.error) {
      setCommitteeSummary({});
      setError({ getCommitteeById: response.error });
    } else {
      setCommitteeSummary(response.data);
    }
  };

  const setDisabledCommittee = async (params) => {
    clearAlerts();
    spinner(true);
    const response = await disabledCommittee(params);
    spinner(false);
    if (response.error) {
      setCommitteesList([]);
      setError({ disabledCommittee: response.error });
    } else {
      setSuccess({ disabled: "disabled" });
      setCommitteesList(response.data);
    }
  };

  const update = async (id, request) => {
    clearAlerts();
    spinner(true);
    const response = await updateCommittee(id, request);
    spinner(false);
    if (response.error) {
      setError({ update: response.error });
    } else {
      setSuccess({ update: "update" });
    }
  };

  const create = async (request) => {
    clearAlerts();
    spinner(true);
    const response = await newCommittee(request);
    spinner(false);
    if (response.error) {
      setError({ create: response.error });
    } else {
      setSuccess({ create: "create" });
    }
  };

  const clearAlerts = () => {
    setSuccess(INITIAL_SUCCESS_ERROR);
    setError(INITIAL_SUCCESS_ERROR);
  };

  const sanitizeForTable = (list, ignore = []) => {
    return list.map((item) => {
      const dataTable = {
        id: item.id,
        name: item.name,
      };
      if (ignore.length > 0) {
        ignore.map((key) => {
          if (Object.keys(dataTable).includes(key)) delete dataTable[key];
        });
      }
      return dataTable;
    });
  };

  return {
    getCommittees,
    sanitizeForTable,
    getCommittee,
    getCommitteesSlot,
    getCommitteesMettings,
    setDisabledCommittee,
    getCommitteesByLanguageId,
    getActiveCommitteesByLanguageId,
    getFinalElevationByLanguageId,
    getCommitteeSummary,
    create,
    update,
    committeesList,
    committeesListSelect,
    finalElevationList,

    committee,
    committeeSummary,
    success,
    error,
  };
};
